import API from "../../../api/index";
import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { boxStyle } from "../../../theme";
import { Stack, Skeleton } from "@mui/material";
import RssFeedIcon from "@mui/icons-material/RssFeed";

const AverageBandwitch = () => {
  const [bandwitch, setBandwitch] = useState(0);
  const [last, setLast] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController()
    API.getPercentile(controller.signal)
      .then((response) => {
        setBandwitch(response.data.percentile);
        if (sessionStorage.getItem("type") === "user") {
          window.sessionStorage.setItem("tipoLecs", response.data.tipo);
        }
        setLast(response.data.last);
      })
      .catch((err) => {
        if (err.name !== 'CanceledError') {
          setBandwitch(0);
          setLast(0);
        }
      })
      .finally(() => setLoading(false));
    return () => controller.abort()
  }, []);

  const formatBandwidth = (value) => {
    if (value > 64000) {
      return `${((value * 8) / 1024 / 1024).toFixed(2)} Gb/s`;
    } else if (value > 20) {
      return `${((value * 8) / 1024).toFixed(2)} Mb/s`;
    } else {
      return `${value * 8} Kb/s`;
    }
  };

  return (
    <Box sx={{ ...boxStyle, display: "flex", flexDirection: "column" }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#888" }}>
          Bandwidth
        </Typography>
        <Box
          sx={{
            width: 36, height: 36, borderRadius: "10px",
            backgroundColor: "rgba(255, 255, 255, 0.06)",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <RssFeedIcon sx={{ fontSize: 18, color: "#888" }} />
        </Box>
      </Stack>

      {loading ? (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width="70%" height={28} sx={{ bgcolor: "rgba(255,255,255,0.08)" }} />
          <Skeleton variant="rounded" width="50%" height={20} sx={{ bgcolor: "rgba(255,255,255,0.08)" }} />
        </Stack>
      ) : (
        <Stack spacing={0.5}>
          <Typography sx={{ fontSize: 22, fontWeight: 600, color: "#fff" }}>
            {formatBandwidth(last)}
          </Typography>
          <Typography sx={{ fontSize: 14, color: "#aaa" }}>
            Avg: {formatBandwidth(bandwitch)}
          </Typography>
        </Stack>
      )}

      <Typography sx={{ fontSize: 12, color: "#555", marginTop: "auto", paddingTop: 1 }}>
        Current network bandwidth usage
      </Typography>
    </Box>
  );
};

export default AverageBandwitch;
